import { memo } from 'react'
import {
  CrewAvatarSize,
  CrewAvatar,
} from 'components/elements/crewAvatar/crewAvatar'
import { generateImageAvatarUrl } from '@crew/utils/avatar'
import { EntityType } from '@crew/enums/domain'
import { useGetLookupUserQuery } from '@crew/apis/lookup/lookupApis'
import { GetUserRequest } from '@crew/apis/lookup/models/getUser/request'
import { skipToken } from '@reduxjs/toolkit/query'

type OwnerItemRenderProps = {
  ownerId?: string
  ownerName?: string
}

export const OwnerItemRender = memo((props: OwnerItemRenderProps) => {
  // ユーザー情報取得（アバターのキャッシュ用にバージョンが必要なため）
  const getUserParam: GetUserRequest | undefined = props.ownerId
    ? {
        userId: props.ownerId,
      }
    : undefined
  const { data: getUserResult } = useGetLookupUserQuery(
    getUserParam ?? skipToken
  )

  return (
    <div className="w-full flex items-center gap-x-2.5">
      {props.ownerName && props.ownerId && (
        <CrewAvatar
          displayName={props.ownerName}
          imageURL={generateImageAvatarUrl(EntityType.User, props.ownerId)}
          size={CrewAvatarSize.xs}
          cacheValue={
            // 型制約上nullチェックが必要なためチェックを行うが、基本はnullになることはない
            getUserResult?.user
              ? getUserResult.user.id + getUserResult.user.version
              : ''
          }
        />
      )}
      <p>{props.ownerName}</p>
    </div>
  )
})
